var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-left":"15px"}},[_c('v-chip',{staticStyle:{"color":"white"},attrs:{"dense":"","color":_vm.chip_bkg_color,"label":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }